import { Injectable, inject } from '@angular/core';
import { TEMPS_ALOFT_PRODUCT_DATA } from './temps-aloft.twc-product-data';
import { TwcRefreshLayerPluginService } from '../../../../../twc.refresh-layer-plugin.service';

@Injectable({
  providedIn: 'root'
})
export class TempsAloftPluginService {
  private readonly _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(TEMPS_ALOFT_PRODUCT_DATA, {
    twcLayerTypes: ['vector-tile']
  });
}
